export interface PropertyMediaInfo {
  id?: number;
  media_name: string;
  media_path: string;
  display_order?: number;
  primary_image_f: boolean;
  ref_property_image_type_desc: string;
  still_video_f: boolean;
  ref_image_size_type_desc: string;
  ref_media_source_system_desc: string;
  /**
   * Flag that determines if the current image can be published online. One of
   * the reasons to not being able to publish an image is because it is a
   * resource that comes from a private source or due to some license
   * restrictions
   */
  publish_image_f: boolean;
  image_cbre_owned_f: boolean;
  media_caption: string;
  image_width: string;
  image_height: string;
  ref_image_orientation_desc: string;
  thumbnail_f: boolean;
  loopnet_image_f: boolean;
  allow_web_view_f: boolean;
  photographer_party_skey: string;
  source_notes: string;
  ref_media_quality_type_desc: string;
  ref_media_view_type_desc: string;
  ref_property_usage_type_desc: string;
  watermark_label: string;
  watermark_precision_probability: string;
  media_type_desc: string;
  file_extension: string;
  file_type: string;
  media_content_type_desc?: MediaContentType;
  sanitized_media_path?: Blob | string;
  media_record_month?: number;
  media_record_year?: number;
}

export interface BrandMediaInfo {
  id: number;
  media_caption: string;
  media_name: string;
  media_path: string;
  media_type_desc: string;
  primary_image_f: boolean;
  file_extension?: string;
  file_type?: string;
}

export interface ActivityMediaInfo {
    id?: number;
    media_name: string;
    media_path: string;
    display_order?: number;
    primary_image_f: boolean;
    media_type_desc: string;
    publish_image_f: boolean;
    activity_image_type_desc: string;
}

export enum MediaContentType {
  Amenities = 'Amenities',
  AreaMap = 'Area Map',
  Brochure = 'Brochure',
  BuildingPhoto = 'Building Photo',
  Cafeteria = 'Cafeteria',
  ConferenceRoom = 'Conference Room',
  Courtyard = 'Courtyard',
  Entrance = 'Entrance',
  EpcCertificate = 'EPC Certificate',
  External = 'External',
  ExternalDetail = 'External Detail',
  Finishes = 'Finishes',
  FloorLayout = 'Floor Layout',
  FloorPlan = 'Floor Plan',
  FlrImage = 'Flr-image',
  Flyer = 'Flyer',
  Folder = 'Folder',
  Interior = 'Interior',
  InternalDetail = 'Internal Detail',
  Lobby = 'Lobby',
  LocImage = 'Loc-image',
  Logo = 'Logo',
  Map = 'Map',
  MarketPhoto = 'Market Photo',
  Neighborhood = 'Neighborhood',
  Other = 'Other',
  ParkView = 'Park View',
  RegistrationDocuments = 'Registration Documents',
  RooftopView = 'Rooftop View',
  SharedSpaceImage = 'Sharedspace-image',
  SitePlan = 'Site Plan',
  StreetView = 'Street View',
  TenancyAgreement = 'Tenancy Agreement',
  Unknown = 'Unknown',
  VirtualTour = 'Virtual_tour',
}

export interface MediaUrlOptions {
  imgSize?: ImageSize;
}

export enum ImageSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export const ImageSizes = {
  small: 200,
  medium: 500,
  large: 1000,
};
